import ImportRowType from '../Models/ImportRowType';
import DataGridRequest from './DataGridRequest';
export class ImportRowRequest extends DataGridRequest<ImportRowType> {
    Url = '../api';
}
